import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';

const Loading = () => {
	return <CircularProgress />;
};

export default Loading;
